import Dinero from "dinero.js"
import { CurrencyCode, formattedCurrencySymbol } from "./currencyUtils"

export const formatAmount = (
  amount: string = "0",
  currency: CurrencyCode = "EUR"
) => {
  if (amount.length === 0) {
    amount = "0"
  }

  const dineroAmount = getDineroAmount(amount)

  const format = dineroAmount.hasSubUnits() ? "0.00" : "0"
  const rawFormatted = dineroAmount.toFormat(format)

  const isNegative = rawFormatted.startsWith("-")
  const rawAbs = isNegative ? rawFormatted.slice(1) : rawFormatted
  const [integerPart, decimalPart] = rawAbs.split(".")

  const groupedIntegerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, " ")
  const numberWithComma =
    decimalPart !== undefined
      ? `${groupedIntegerPart},${decimalPart}`
      : groupedIntegerPart

  const formatted = `${isNegative ? "-" : ""}${numberWithComma}`

  return `${formatted} ${formattedCurrencySymbol(currency)}`
}

export const getDineroAmount = (amount: string) => {
  const amountInCents = Math.round(
    Number(parseFloat(amount.replace(",", ".")).toFixed(2)) * 100
  )

  const dineroAmount = Dinero({ amount: amountInCents })
  return dineroAmount
}
